export const BROWSE_PRODUCT = "/browse/product/";
